import { cva } from 'class-variance-authority'

export const datePickerStyles = cva(
  `
    rounded-lg
    shadow-lg
    bg-neutral-0
    overflow-hidden
    flex
    [&_.react-datepicker__current-month]:!m-2
    [&_.react-datepicker__header_.react-datepicker__current-month]:!m-2
    [&_.react-datepicker__month-container_.react-datepicker__header_.react-datepicker__current-month]:!m-2
  `,
  {
    variants: {
      variant: {
        default: '',
        range: `
          [&_.react-datepicker__month-container]:ml-[240px]
          [&_.react-datepicker__month-container]:pr-4
          [&_.react-datepicker__month-container]:pt-4
          [&_.react-datepicker__month-container]:pb-16
          [&_.react-datepicker__header]:ml-[240px]
          [&_.react-datepicker__header]:mr-4
          [&_.react-datepicker__navigation]:ml-[240px]
        `,
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const yearContainerStyles = cva(
  `
    m-0
    p-4
  `
)

export const yearWrapperStyles = cva(
  `
    grid
    grid-cols-3
    gap-3
    max-w-full
  `
)

export const yearTextStyles = cva(
  `
    inline-flex
    items-center
    justify-center
    w-full
    h-10
    m-0
    px-4
    py-2
    rounded-lg
    bg-neutral-0
    text-neutral-800
    text-sm
    font-medium
    leading-none
    cursor-pointer
    transition-all
    duration-150
    ease-in-out
  `,
  {
    variants: {
      state: {
        default: 'hover:bg-neutral-25 hover:border-neutral-400',
        selected: 'bg-brand-0 border-brand-50 text-brand-800',
        disabled:
          'text-neutral-400 bg-neutral-25 border-neutral-200 cursor-not-allowed',
        today: 'font-semibold',
      },
    },
    defaultVariants: {
      state: 'default',
    },
  }
)

export const navigationStyles = cva(
  `
    bg-neutral-0
    rounded
    w-7
    h-7
    flex
    items-center
    justify-center
    top-3
  `,
  {
    variants: {
      position: {
        previous: 'right-12',
        next: 'right-3',
      },
    },
  }
)

export const leftPanelStyles = cva(
  `
    p-8
    bg-neutral-25
    min-w-[240px]
    w-[240px]
    flex
    flex-col
    gap-6
    flex-shrink-0
  `
)

export const monthContainerStyles = cva(
  `
    flex-1
    flex
    flex-row
  `
)

export const calendarSectionStyles = cva(
  `
    flex-1
    flex
    flex-col
    p-4
  `
)

export const currentMonthStyles = cva(
  `
    text-base
    font-semibold
    text-gray-800
    mb-2
  `
)

export const dayNameStyles = cva(
  `
    text-gray-500
    text-sm
    font-medium
    w-9
    leading-9
  `
)

export const footerStyles = cva(
  `
    p-4
    flex
    justify-end
    gap-3
    bg-neutral-0
    mt-auto
  `
)

export const calendarWrapperStyles = cva(
  `
    ml-[240px]
    pr-4
    pt-4
    pb-16
  `
)

export const cancelButtonStyles = cva(
  `
    text-gray-700
    hover:text-gray-900
    font-medium
  `
)
